(function () {
    "use strict";

    // @ngInject
    function TextOverImageComponentControllerFunc($injector, $scope, $sce, AnalyticsService, ModalService, ImageService, UIUtils) {
        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'TextOverImageComponentDirectiveController';
        this.$sce = $sce;
        this.AnalyticsService = AnalyticsService;
        this.ImageService = ImageService;
        this.ModalService = ModalService;
        this.UIUtils = UIUtils;

        // this.toolbar = ['fontFamily', '|', 'fontSize', '|', 'bold', '|', 'underline', '|', 'italic', '|', 'fontColor', '|', 'alignment' ,'|', 'link', '|', 'undo'];
        this.toolbar = ['fontFamily', '|', 'fontSize', '|', 'bold', '|', 'underline', '|', 'italic', '|', 'fontColor', '|', 'link', '|', 'removeFormat', '|', 'undo'];

    }

    var TextOverImageComponentDirectiveController = Class(Controllers.BaseController, {
        constructor: TextOverImageComponentControllerFunc,

        updateContent: function updateContent() {
            this.component.updateContent();
            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.saved_block, { field: 'content', block_type: "text over image"});
        },

        renderContent: function renderContent(content) {
            return this.$sce.trustAsHtml(content);
        },

        getImageUrl: function getImageUrl() {
            var imageModel = this.component.image;
            if (imageModel) {
                return this.ImageService.getHBImageCloudinaryUrl(imageModel);
            }
        },

        onChooseImage: function onChooseImage() {
            if (this.component.image) {
                this.editImage();
            } else {
                this.addImage();
            }
        },

        addImage: function addImage() {
            this.changeImage('MEDIA_MODAL.TITLE._ADD_IMAGE_', '', 'Upload');
            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.add_block_image);
        },

        editImage: function editImage() {
            this.changeImage('MEDIA_MODAL.TITLE._EDIT_IMAGE_', this.component.image, 'Crop');
            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.edit_block_image);
        },

        changeImage: function changeImage(modalTitle, modalImage, defaultTab) {
            return this.ModalService.openAttachAssetModal(true, true, true,
                defaultTab, false, false, modalImage, this.imageRatio,
                false, false, 'image/*', '', '', modalTitle)
                .then(function success(image){
                    this.saveImage(angular.copy(image));
                }.bind(this))
                .finally(function () {
                }.bind(this));
        },

        saveImage: function saveImage(imageModel) {
            this.component.image = imageModel;
            this.component.saveImage();
        },

    });

    Components.TextOverImageComponent = {
        bindings: {
            component: '=',
            isEditable: '<'
        },
        templateUrl: 'angular/app/modules/core/features/dynamic_content/components/text_over_image/text_over_image_component.html',
        controller: TextOverImageComponentDirectiveController,
        controllerAs: 'textOverImageComponentVm',
        name: 'hbTextOverImageComponent'
    };

}());



